import { arrayOf, object, shape, string } from './type-checkers.js';
const validatorShape = {
    name: string,
    options: object,
};
const validator = shape(validatorShape)
    .type('validators');
const validators = arrayOf(validator)
    .type('list')
    .group('validations');
export { validators, };
//# sourceMappingURL=validators.js.map